import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
// 一级页面
//入口
const Index = resolve => require(['@/views/IndexViews/Index'], resolve)
//首页
const Home = resolve => require(['@/views/HomeViews/Home'], resolve);
const HomeSearch = resolve => require(['@/views/HomeViews/HomeSearch'], resolve)
// const Refresh = resolve => require(['@/views/OtherViews/Refresh'], resolve)

//政策解读
const Policy = resolve => require(['@/views/PolicyViews/Policy'], resolve)
const PolicySearch = resolve => require(['@/views/PolicyViews/PolicySearch'], resolve)
//政策申请
const PolicyApply = resolve => require(['@/views/PolicyViews/PolicyApply'], resolve)
//政策资料评审
const PolicyReview = resolve => require(['@/views/PolicyViews/PolicyReview'], resolve)
//政策咨询
const PolicyConsultView = resolve => require(['@/views/PolicyViews/PolicyConsultView'], resolve)
//申报通知
const Declaration = resolve => require(['@/views/DeclarationViews/Declaration'], resolve)
//政银企互动
const GBCInteraction=resolve => require(['@/views/GBCInteraction/GBCInteraction'], resolve)
//政银企互动
const GBCInteractionConsult=resolve => require(['@/views/GBCInteractionConsult/GBCInteractionConsult'], resolve)
//第三方服务
const ThirdParty = resolve => require(['@/views/ThirdPartyViews/ThirdParty'], resolve)
//创新服务券
const Innovative = resolve => require(['@/views/InnovativeViews/Innovative'], resolve);
//高新风采
const NewStyle = resolve => require(['@/views/NewStyleViews/NewStyle'], resolve)

//登录
const Login = resolve => require(['@/views/UserInforViews/Login'], resolve)
//忘记密码
const ForgetPassword = resolve => require(['@/views/UserInforViews/ForgetPassword'], resolve)
//重置密码
const ResetPwd = resolve => require(['@/views/UserInforViews/ResetPwd'], resolve)
//注册
const Register = resolve => require(['@/views/UserInforViews/Register'], resolve)
//第三方服务机构页面
const ServiceOrganization = resolve => require(['@/views/ServiceOrganization'], resolve)
//第三方服务机构详情页面
const ServiceOrganizationInfo = resolve => require(['@/views/ServiceOrganization/info'], resolve)
//第三方服务服务详情页面
const ServiceInfo = resolve => require(['@/views/ServiceOrganization/serviceInfo'], resolve)
//第三方服务产品购买页面
const BuyInfor = resolve => require(['@/views/ServiceOrganization/buyInfor'], resolve)

//更多资讯页面
const InforList = resolve => require(['@/views/InformationViews/InforList'], resolve)
//隐私声明页面
const PrivacyAgreement = resolve => require(['@/views/OtherViews/PrivacyAgreement'], resolve)
//用户协议页面
const UserAgreement = resolve => require(['@/views/OtherViews/UserAgreement'], resolve)
//联系我们页面
const ContactUs = resolve => require(['@/views/OtherViews/ContactUs'], resolve)
//详情页面
const ArticleDetail = resolve => require(['@/views/ArticleDetail'], resolve)
//404页面
const Error = resolve => require(['@/views/OtherViews/Error'], resolve)
//政策申报条款页面
const PolicyTerms = resolve => require(['@/views/OtherViews/PolicyTerms'], resolve)



//处理路由重复报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//  路由配置
let router= new Router({
  mode:'history',
  linkActiveClass:'my-active',
  routes: [
    {
      path: '/',
      component: Index,
      children: [{
        path: '/',
        name: 'Index',//入口
        redirect:'/index'
      },{
        path: '/index',
        name: 'Home',//首页
        component: Home,
        meta:{
          keepAlive: true//缓存
        }
      },
      // {
      //   path: '/refresh',
      //   name: 'Refresh',//刷新
      //   component: Refresh,
      //   meta:{
      //     keepAlive: false//缓存
      //   }
      // },
      {
        path: '/homeSearch',
        name: 'HomeSearch',//首页-搜索
        component: HomeSearch,
        meta:{
          isHasbgColor:true,
          keepAlive: false,//缓存
           //面包屑
           breadList: [
            {
              name: '首页',
              path: '/index'
            },
            {
              name: '搜索结果',
              path: '/homeSearch'
            },
          ],
        }
      },{
          path: '/policy',
          name: 'Policy',//政策解读
          component: Policy,
          meta:{
            isHasbgColor:true,
            keepAlive: true,//缓存
            //面包屑
            breadList: [
              {
                name: '首页',
                path: '/'
              }, {
                name: '政策解读',
                path: '/policy'
              }
            ],
          }
        },
        {
          path: '/policySearch',
          name: 'PolicySearch',//政策解读
          component: PolicySearch,
          meta: {
            isHasbgColor: true,
            keepAlive: true,//缓存
            //面包屑
            breadList: [
              {
                name: '政策解读',
                path: '/policy'
              },
              {
                name: '政策匹配',
                path: '/policySearch'
              },
            ],
          }
        },
        {
          
          path: '/policyApply/:code',
          name: 'PolicyApply',//政策申请
          component: PolicyApply,
          meta:{
            isHasbgColor:true,
            keepAlive: false,//缓存
            //面包屑
            breadList: [
              {
                name: '政策解读',
                path: '/policy'
              }, {
                name: '政策详情',
                path:'/detail'
              },{
                name: '政策申请'
              }
            ],
          }
        },
        {
          
          path: '/policyReview/:code',
          name: 'policyReview',//政策申请-资料评审
          component: PolicyReview,
          meta:{
            isHasbgColor:true,
            keepAlive: false,//缓存
            //面包屑
            breadList: [
              {
                name: '政策解读',
                path: '/policy'
              }, {
                name: '政策详情',
                path:'/detail'
              },{
                name: '政策申请'
              }
            ],
          }
        },
        {
          
          path: '/policyConsultView/:code',
          name: 'PolicyConsultView',//政策咨询
          component: PolicyConsultView,
          meta:{
            isHasbgColor:true,
            keepAlive: false,//缓存
            //面包屑
            breadList: [
              {
                name: '政策解读',
                path: '/policy'
              }, {
                name: '政策详情',
                path:'/detail'
              },{
                name: '政策咨询'
              }
            ],
          }
        },
        {
          path: '/declaration',
          name: 'Declaration',//申报通知
          component: Declaration,
          meta:{
            isHasbgColor:true,
            keepAlive: true//缓存
          }
        },
        {
          path: '/GBCInteraction',
          name: 'GBCInteraction',//政银企互动
          component: GBCInteraction,
          meta:{
            isHasbgColor:true,
            keepAlive: true//缓存
          }
        },
        {
          path: '/GBCInteractionConsult',
          name: 'GBCInteractionConsult',//政银企互动咨询
          component: GBCInteractionConsult,
          meta:{
            isHasbgColor:true,
            keepAlive: true,//缓存
            //面包屑
            breadList: [
              {
                name: '首页',
                path: '/'
              },{
                name: '政银企互动',
                path: '/GBCInteraction'
              },{
                name: '详情'
              }
            ],
          }
        },
        {
          path: '/thirdParty',
          name: 'ThirdParty',//第三方服务
          component: ThirdParty,
          meta:{
            isHasbgColor:true,
            keepAlive: true//缓存
          }
        },
        {
          path: '/newStyle',
          name: 'NewStyle',//高新风采
          component: NewStyle,
          meta:{
            isHasbgColor:true,
            keepAlive: true//缓存
          }
        },
        {
          path: '/innovative',
          name: 'Innovative',//创新服务券
          component: Innovative,
          meta:{
            isHasbgColor:true,
            keepAlive: true//缓存
          }
        },
        {
          path: '/inforList',
          name: 'InforList',//资讯列表
          component: InforList,
          meta:{
            isHasbgColor:true,
            keepAlive: true//缓存
          }
        },
        {
          path: '/serviceOrganization',
          name: 'ServiceOrganization',//第三方服务机构
          component: ServiceOrganization,
          meta: {
            isHasbgColor:true,
            //面包屑
            breadList:[
              {
                name:'首页',
                path:'/'
              },{
                name:'第三方服务机构',
                path:'/serviceOrganization'
              }
            ],
            keepAlive: true//缓存
          }
        }, 
        {
          path: '/serviceOrganization/:code',
          name: 'ServiceOrganizationInfo',//第三方服务机构详情
          component: ServiceOrganizationInfo,
          meta: {
            isHasbgColor: true,
            //面包屑
            breadList: [
              {
                name: '首页',
                path: '/'
              }, {
                name: '第三方服务机构',
                path: '/serviceOrganization'
              }, {
                name: '详情'
              }
            ],
            keepAlive: true//缓存
          }
        }, {
          path: '/serviceInfo/:code',
          name: 'ServiceInfo',//第三方服务机构服务详情
          component: ServiceInfo,
          meta: {
            isHasbgColor: true,
            //面包屑
            breadList: [
              {
                name: '首页',
                path: '/'
              }, {
                name: '第三方服务机构',
                path: '/serviceOrganization'
              }, {
                name: '服务详情'
              }
            ],
            keepAlive: true//缓存
          }
        },
        {
          path: '/buyInfor/:code',
          name: 'buyInfor',//第三方服务机构-购买
          component: BuyInfor,
          meta: {
            isHasbgColor: true,
            keepAlive: true,//缓存
            login:true//需要登录
          }
        },
        {
          path: '/contactUs',
          name: 'ContactUs',//联系我们页面
          component: ContactUs,
          meta:{
            isHasbgColor:true,
            keepAlive: true//缓存
          }
        },
        {
          path: '/privacyAgreement',
          name: 'PrivacyAgreement',//隐私协议页面
          component: PrivacyAgreement,
          meta:{
            isHasbgColor:true,
            keepAlive: true//缓存
          }
        },
        {
          path: '/userAgreement',
          name: 'UserAgreement',//用户协议页面
          component: UserAgreement,
          meta:{
            isHasbgColor:true,
            keepAlive: true//缓存
          }
        }, {
          path: '/detail/:code',
          name: 'ArticleDetail',//文章详情
          component: ArticleDetail,
          meta: {
            isHasbgColor: true,
            keepAlive: true//缓存
          }
        },
        {
          path: '/policyTerms',
          name: 'PolicyTerms',//政策申报条款
          component: PolicyTerms,
          meta:{
            isHasbgColor:true,
            keepAlive: true//缓存
          }
        },
        {
          path: '/login',
          name: 'Login',//登录
          component: Login,
          meta:{
            isHasbgColor:true,
            keepAlive: true//缓存
          }
        },
        {
          path: '/register',
          name: 'Register',//注册
          component: Register,
          meta:{
            isHasbgColor:true,
            keepAlive: true//缓存
          }
        },
        {
          path: '/forgetPassword',
          name: 'ForgetPassword',//忘记密码
          component: ForgetPassword,
          meta:{
            isHasbgColor:true,
            keepAlive: true//缓存
          }
        },
        {
          path: '/resetPwd',
          name: 'ResetPwd',//重置密码
          component: ResetPwd,
          meta:{
            isHasbgColor:true,
            keepAlive: true//缓存
          }
        },
        {
          path: '*',//排除以上路由
          name: 'Error',//注册
          component: Error,
          meta:{
            isHasbgColor: true,
            keepAlive: true//缓存
          }
        }
      ]
    }

    
  ]
})
export default router
 


// WEBPACK FOOTER //
// ./src/router/index.js